let _pixelLoaded = false;

export const initMetaPixel = (pixelId) => {
    if (!pixelId || _pixelLoaded) return;
    _pixelLoaded = true;
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
};

export const trackMetaEvent = (eventName, params, options) => {
    if (!window.fbq) return;
    if (options) {
        window.fbq('track', eventName, params || {}, options);
    } else {
        window.fbq('track', eventName, params || {});
    }
};
